/* Cart Boost: delivery date and countdown, discount code and free gift for Dunknation's cart drawer (Dawn based). */
(function () {
  'use strict';

  var root = (window.routes && window.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';

  /* Re-render the drawer from a Cart API response that carries `sections`, without forcing it open. */
  function render(state) {
    var drawer = document.querySelector('cart-drawer');
    if (!state || !state.sections) return;
    if (drawer && state.sections['cart-drawer']) {
      var html = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
      var fresh = html.querySelector('#CartDrawer');
      var current = document.getElementById('CartDrawer');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      drawer.classList.toggle('is-empty', state.item_count === 0);
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.toggle('is-empty', state.item_count === 0);
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && state.sections['cart-icon-bubble']) {
      var b = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-boost', cartData: state });
    }
  }

  function post(path, body) {
    body.sections = ['cart-drawer', 'cart-icon-bubble'];
    body.sections_url = window.location.pathname;
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw j;
        return j;
      });
    });
  }

  function define(name, cls) {
    if (!customElements.get(name)) customElements.define(name, cls);
  }

  /* Delivery date + order-within countdown */
  function zoned(tz) {
    var parts = {};
    try {
      new Intl.DateTimeFormat('en-US', {
        timeZone: tz || undefined,
        hourCycle: 'h23',
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric',
      }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    } catch (e) {
      var d = new Date();
      parts = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate(), hour: d.getHours(), minute: d.getMinutes(), second: d.getSeconds() };
    }
    /* A naive date: UTC fields hold the store's local wall-clock time. */
    return new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute, +parts.second));
  }

  define('cb-eta', class extends HTMLElement {
    connectedCallback() {
      this.out = this.querySelector('[data-eta]');
      if (!this.out) return;
      this.tick = this.update.bind(this);
      this.update();
      this.timer = setInterval(this.tick, 30000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    update() {
      var ds = this.dataset;
      var min = parseInt(ds.min, 10) || 0;
      var max = Math.max(parseInt(ds.max, 10) || min, min);
      var skip = (ds.skip || '').split(',').filter(function (s) { return s.trim() !== ''; }).map(Number);
      var cutoff = ds.cutoff === '' || ds.cutoff === undefined ? null : parseInt(ds.cutoff, 10);
      var now = zoned(ds.tz);
      var day = 86400000;
      var isWork = function (d) { return skip.indexOf(d.getUTCDay()) === -1; };
      var midnight = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));

      /* Dispatch day: today if it is a working day and (no cutoff or before cutoff), else next working day. */
      var dispatch = midnight;
      if (cutoff !== null) {
        if (!isWork(dispatch) || now.getUTCHours() >= cutoff) {
          dispatch = new Date(dispatch.getTime() + day);
          while (!isWork(dispatch)) dispatch = new Date(dispatch.getTime() + day);
        }
      }
      var add = function (from, n) {
        var d = from;
        while (n > 0) {
          d = new Date(d.getTime() + day);
          if (isWork(d)) n--;
        }
        return d;
      };
      var a = add(dispatch, min);
      var b = add(dispatch, max);
      var lang = ds.lang || document.documentElement.lang || 'en';
      var fmt = function (d) {
        try {
          return d.toLocaleDateString(lang, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
        } catch (e) {
          return d.toUTCString().slice(0, 11);
        }
      };
      var date = a.getTime() === b.getTime() ? fmt(a) : fmt(a) + ' – ' + fmt(b);
      var esc = function (x) {
        return String(x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
      };
      var text = esc(ds.tOn || 'Estimated arrival [date]').replace('[date]', '<b>' + esc(date) + '</b>');

      if (cutoff !== null) {
        var deadline = dispatch.getTime() + cutoff * 3600000;
        var left = deadline - now.getTime();
        if (left > 0 && left <= day) {
          var h = Math.floor(left / 3600000);
          var m = Math.floor((left % 3600000) / 60000);
          var time = (h ? h + ' h ' : '') + m + ' min';
          text += ' ' + esc(ds.tWithin || 'if you order within [time]').replace('[time]', '<b>' + esc(time) + '</b>');
        }
      }
      this.out.innerHTML = text;
      this.hidden = false;
    }
  });

  /* Discount code field. Dawn re-renders the drawer footer after every cart change, so a pending
     error is kept for a few seconds and shown again by whichever field element connects next. */
  var pendingError = null;
  function showError(el) {
    if (!pendingError || Date.now() - pendingError.at > 4000) return;
    var err = el.querySelector('.cb-discount__error');
    var input = el.querySelector('input');
    if (input && pendingError.code) input.value = pendingError.code;
    if (err) {
      err.textContent = pendingError.msg;
      err.hidden = false;
    }
  }
  define('cb-discount', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      showError(this);
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
    }
    codes() {
      return (this.dataset.codes || '').split(',').filter(Boolean);
    }
    onClick(e) {
      var btn = e.target.closest('[data-remove]');
      if (!btn) return;
      var gone = btn.getAttribute('data-remove');
      pendingError = null;
      this.apply(this.codes().filter(function (c) { return c !== gone; }), null);
    }
    onSubmit(e) {
      e.preventDefault();
      var input = this.form.querySelector('input');
      var code = (input.value || '').trim();
      if (!code) return;
      var list = this.codes();
      if (list.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) === -1) list.push(code);
      this.apply(list, code);
    }
    apply(list, added) {
      var self = this;
      var msg = this.dataset.error || 'This code cannot be applied to your cart.';
      this.classList.add('is-loading');
      post('cart/update.js', { discount: list.join(',') })
        .then(function (state) {
          var bad = added && (state.discount_codes || []).some(function (d) {
            return d.code.toLowerCase() === added.toLowerCase() && !d.applicable;
          });
          if (!bad) {
            pendingError = null;
            return render(state);
          }
          /* Not applicable: take it back off so the cart stays clean, then say so. */
          pendingError = { msg: msg, code: added, at: Date.now() };
          return post('cart/update.js', { discount: list.filter(function (c) { return c !== added; }).join(',') }).then(function (s2) {
            render(s2);
            var el = document.querySelector('cb-discount');
            if (el) showError(el);
          });
        })
        .catch(function () {
          pendingError = { msg: msg, code: added, at: Date.now() };
          showError(self);
        })
        .finally(function () {
          self.classList.remove('is-loading');
        });
    }
  });

  /* Free gift: Liquid decides (add / one / remove / none); this only carries it out once. */
  var giftBusy = false;
  var giftFailed = false;
  define('cb-gift', class extends HTMLElement {
    connectedCallback() {
      var action = this.dataset.action;
      if (!action || action === 'none' || giftBusy || giftFailed) return;
      giftBusy = true;
      var job;
      if (action === 'add') {
        job = post('cart/add.js', { items: [{ id: Number(this.dataset.variant), quantity: 1, properties: { _cb_gift: '1' } }] })
          .then(function () { return post('cart/update.js', {}); });
      } else {
        job = post('cart/change.js', { id: this.dataset.key, quantity: action === 'one' ? 1 : 0 });
      }
      job
        .then(function (state) {
          giftBusy = false;
          render(state);
        })
        .catch(function () {
          giftBusy = false;
          giftFailed = true;
        });
    }
  });

  /* Product page code: tap to copy */
  define('cb-copy', class extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('.cb-code__btn');
      var code = this.dataset.code;
      var done = this.dataset.copied || 'Copied';
      if (!btn) return;
      btn.addEventListener('click', function () {
        var reset = function () {
          var old = btn.textContent;
          btn.textContent = done;
          setTimeout(function () { btn.textContent = old === done ? code : old; }, 1400);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(reset, reset);
        else reset();
      });
    }
  });
})();
